import { useLocale } from '../../../context/NbLocalizationContext';
import { NbLoader } from '../../../shared/components/loader/Loader';

import { defaultMessageGroups, Loadable, Message } from '@eih-netbroker/common';
import { useCallback, useMemo } from 'react';
import { ErrorWidgetContent } from '../../../shared/components/error-widget-content/ErrorWidgetContent';
import { useNotification } from '../services/useNotification';
import classes from './MessageCenterList.module.scss';
import { MessageCenterListRow } from './MessageCenterListRow';

export const MessageCenterList = () => {
  const { translation } = useLocale();
  const { readMessageById, loadMessageGroups, messages, showOnlyUnread, activeCategory } = useNotification();

  const filteredMessages = useMemo(() => {
    const messageGroup = Loadable.getOrElse(messages, { groups: defaultMessageGroups }).groups[activeCategory];

    if (showOnlyUnread) {
      return messageGroup.filter(alert => !alert.isRead);
    }

    return messageGroup;
  }, [messages, showOnlyUnread, activeCategory]);

  const handleOnMessageClick = useCallback((message: Message) => readMessageById(message.id), [readMessageById]);

  const handleOnReloadClick = useCallback(() => {
    loadMessageGroups();
  }, [loadMessageGroups]);

  return (
    <ul className={`${classes.list} ${filteredMessages.length === 0 ? classes.listIsEmpty : ''}`}>
      {messages.isLoading && !Loadable.hasValue(messages) && (
        <NbLoader
          verticalCenter
          horizontalCenter
        />
      )}
      {messages.hasError && <ErrorWidgetContent onClick={handleOnReloadClick} />}
      {Loadable.hasValue(messages) && (
        <>
          {filteredMessages.length === 0 && !showOnlyUnread && <span>{translation.messageCenter.noNewAlert}</span>}
          {filteredMessages.length === 0 && showOnlyUnread && <span>{translation.messageCenter.noUnreadAlert}</span>}

          {filteredMessages.map(message => (
            <MessageCenterListRow
              key={message.id}
              onMessageClick={handleOnMessageClick}
              message={message}
            />
          ))}
        </>
      )}
    </ul>
  );
};
